import script from "./ThePersonal.vue?vue&type=script&setup=true&lang=js"
export * from "./ThePersonal.vue?vue&type=script&setup=true&lang=js"

import "./ThePersonal.vue?vue&type=style&index=0&id=0f696020&lang=css"
import "./ThePersonal.vue?vue&type=style&index=1&id=0f696020&lang=css"

const __exports__ = script;

export default __exports__